import React from 'react';

// This component is now just a placeholder since the cookie consent logic
// has been moved to index.html for proper initialization order
export default function CookieConsent() {
  return null;
}